import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// import { TableColumn } from 'src/app/components/table/table.component';
import Utils, { GetHelper } from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SignupService } from 'src/app/services/signup/signup.service';

export type PersonIncomeOthersValues = {
  type: string;
  current_value: string;
  description: string;
  id: number;
};

@Component({
  selector: 'app-signup-unified-person-income-others',
  templateUrl: './signup-unified-person-income-others.component.html',
  styleUrls: ['./signup-unified-person-income-others.component.scss'],
})
export class SignupUnifiedPersonIncomeOthersComponent implements OnInit {
  form = this.formBuilder.group({
    type: [null, [Validators.required]],
    current_value: [null, [Validators.required]],
    description: [null, []],
  });

  columns: any[] = [
    { name: 'Tipo', cell: (row) => row.type },
    {
      name: 'Descrição',
      cell: (row) => row.description,
    },
    {
      name: 'Valor atual',
      cell: (row) => Utils.formatBrl(Number(row.current_value)),
    },
  ];

  data: Partial<PersonIncomeOthersValues>[] = [];

  footerData: Partial<PersonIncomeOthersValues>[] = [];

  showForm = true;

  addingOthers = false;
  removingOthers = false;
  loading = false;
  showDeleteModal = false;
  selectedIndexToDelete: number | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private signupService: SignupService,
    private api: ApiService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Para cotista PF, outros bens são obrigatórios - deve ter pelo menos um item
    this.updateFormStatus();

    this.getData();
  }

  setFooterData() {
    const total = String(
      this.data.reduce(
        (prev, curr) => Number(prev) + Number(curr.current_value ?? 0),
        0
      )
    );

    this.footerData = [
      {
        type: '<span><strong>Total declarado</strong></span>',
        current_value: total,
      },
    ];
  }

  async getData() {
    this.loading = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        console.error('Register UUID não encontrado na URL');
        this.loading = false;
        return;
      }

      const { data } = await this.api.get({
        route: 'api/registration/other-assets/',
        params: { register_uuid: routeId },
        token: true,
      });

      this.data = data;
      // Atualizar status baseado na validação
      this.updateFormStatus();

      this.showForm = this.data.length === 0;

      this.setFooterData();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  async addNewOthers() {
    this.addingOthers = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        console.error('Register UUID não encontrado na URL');
        this.addingOthers = false;
        return;
      }

      const valuesHelper = new GetHelper(this.form.value);

      const payload = {
        type: valuesHelper.get('type'),
        current_value: valuesHelper.get('current_value'),
        description: valuesHelper.get('description'),
      };

      await this.api.post({
        route: 'api/registration/other-assets/',
        params: { register_uuid: routeId },
        token: true,
        body: payload,
      });

      this.form.reset();

      // Ativar loading antes de recarregar os dados
      await this.getData();

      // Atualizar status após adicionar
      this.updateFormStatus();
    } catch (error) {
      console.log(error);
    } finally {
      this.addingOthers = false;
    }
  }

  handleOpenDeleteModal(index: number) {
    this.selectedIndexToDelete = index;
    this.showDeleteModal = true;
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.selectedIndexToDelete = null;
  }

  async confirmDeleteOthers() {
    if (this.selectedIndexToDelete === null) {
      return;
    }

    this.removingOthers = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        console.error('Register UUID não encontrado na URL');
        this.removingOthers = false;
        return;
      }

      await this.api.delete({
        route: `api/registration/other-assets/${
          this.data[this.selectedIndexToDelete].id
        }/`,
        params: { register_uuid: routeId },
        token: true,
      });

      // Ativar loading antes de recarregar os dados
      await this.getData();

      // Atualizar status após remover
      this.updateFormStatus();
    } catch (error) {
      console.log(error);
    } finally {
      this.removingOthers = false;
      this.closeDeleteModal();
    }
  }

  buttonDisabled() {
    if (this.showForm) {
      const type = this.form.controls.type.value;
      const currentValue = this.form.controls.current_value.value;
      // Permite zero ou null, mas desabilita o botão se for zero, null ou vazio
      // Não dá erro de validação, apenas desabilita o botão
      return (
        type === null ||
        type === '' ||
        currentValue === null ||
        currentValue === 0 ||
        currentValue === ''
      );
    }

    return false;
  }

  triggerForm() {
    if (this.showForm) {
      this.addNewOthers();
    }

    this.showForm = !this.showForm;
  }

  handleCancel() {
    this.showForm = false;
    this.form.reset();
  }

  // Novo método para atualizar o status do formulário
  updateFormStatus() {
    // Para cotista PF, é obrigatório ter pelo menos um item
    const isValid = this.data && this.data.length > 0;
    this.signupService.setPersonFormStatus('incomeOthers', isValid);
  }
}
